/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedTabularProductDataListDto } from '../../models/backend-paginated-tabular-product-data-list-dto';
import { BackendTabularProductDataRequestDto } from '../../models/backend-tabular-product-data-request-dto';

export interface SalesTabularProductsDataUpdate$XWwwFormUrlencoded$Params {
  id: number;

  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  body: Array<BackendTabularProductDataRequestDto>;
}

export function salesTabularProductsDataUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: SalesTabularProductsDataUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedTabularProductDataListDto>> {
  const rb = new RequestBuilder(rootUrl, salesTabularProductsDataUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedTabularProductDataListDto>;
    }),
  );
}

salesTabularProductsDataUpdate$XWwwFormUrlencoded.PATH = '/api/sales/tabular-products-data/{id}/';
